export enum ServerEvent {
  order_changed = 'order_changed',
}

export class ServerSentEvent<T = Record<string, any>> {
  Type: string;
  MessageId: string;
  TopicArn: string;
  Subject: string;
  Message: T;
  Timestamp: Date;

  constructor(event: ServerSentEvent<string>) {
    this.Type = event.Type;
    this.MessageId = event.MessageId;
    this.TopicArn = event.TopicArn;
    this.Subject = event.Subject;
    this.Timestamp = new Date(event.Timestamp);

    try {
      this.Message = JSON.parse(event.Message);
    } catch (err) {
      console.log(err, event.Message);
      this.Message = {} as T;
    }
  }
}
